module.exports = __webpack_public_path__ + "media/images/emblems/Schleinikon-blazon-de6b3cd4c88e0da3eec876eb703f8001.svg";